import SectionLabel from "../items/SectionLabel";
import { SkillCard } from "../items/SkillCard";

import { forwardRef } from "react";
function SkillsComponent(
  props: JSX.IntrinsicAttributes,
  ref: React.ForwardedRef<HTMLDivElement>
): JSX.Element {
  return (
    <section className="section-container" ref={ref} {...props}>
      <SectionLabel title="Skills" />
      <div className="skills-container">
        <div className="skills-label-container">
          <h3 className="skills-section-label">using now:</h3>
        </div>
        <div className="skills-list">
          <SkillCard name="html5" icon="cib:html5-shield" color="#e34c26" />
          <SkillCard name="css" icon="cib:css3-shiled" color="#00A0E4" />
          <SkillCard name="sass" icon="logos:sass" />
          <SkillCard name="firebase" icon="logos:firebase" />
          <SkillCard name="typescript" icon="logos:typescript-icon" />
          <SkillCard name="next" icon="logos:nextjs-icon" />
          <SkillCard name="react" icon="logos:react" color="#00D1F7" />
          <SkillCard name="javascript" icon="logos:javascript" />
        </div>
      </div>
      <div className="skills-container">
        <div className="skills-label-container">
          <h3 className="skills-section-label">learning:</h3>
        </div>{" "}
        <div className="skills-list">
          <SkillCard name="nodejs" icon="logos:nodejs-icon" />
          <SkillCard name="git" icon="logos:git-icon" />
          <SkillCard
            name="rest"
            icon="dashicons:rest-api"
            color="lightseagreen"
          />
        </div>
      </div>
    </section>
  );
}
export const Skills = forwardRef(SkillsComponent);
